// extracted by css-extract-rspack-plugin
export default {"cls1":"shared-cls1_4co","cls2":"shared-cls2_0KF shared-cls1_4co"};